export default __webpack_public_path__ + "static/TM-Primary-Care-logo-9638bdba9d216e2d703ced2c0fe66a30.png";